<template>
  <main-dialog :is-visible.sync="computedIsVisible" v-bind="dialogBind">
    <template #body>
      <v-col cols="12" class="px-0">
        <v-row no-gutters>
          <v-col cols="12" class="text-left text-body-2">
            {{ content }}
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-4">
          <v-col cols="auto" class="text-left text-body-2">
            <v-row no-gutters v-for="(error, idx) of errors" :key="idx">
              <v-tooltip bottom color="font" :disabled="!error.error">
                <template #activator="{ on }">
                  <v-row no-gutters v-on="on" class="pb-2">
                    <v-col cols="auto">
                      <v-icon color="error" class="pr-1" size="18">
                        mdi-close-circle
                      </v-icon>
                    </v-col>
                    <v-col cols="auto">
                      {{ error.title }}
                    </v-col>
                  </v-row>
                </template>
                {{ error.error }}
              </v-tooltip>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </template>
  </main-dialog>
</template>
<script>
import MainDialog from '@/components/MainDialog';
export default {
  name: 'TableButtonsCopyObjectsGeometryErrorsDialog',
  components: { MainDialog },
  props: {
    errors: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isVisible: {
      type: Boolean,
    },
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    content() {
      return this.$i18n.t('sidebar.copyObjectsGeometry.errorsBody', { count: this.errorsCount });
    },
    dialogBind() {
      return {
        disagreeText: 'dialog.close',
        hasAgree: false,
        title: this.$i18n.t('sidebar.copyObjectsGeometry.errorsTitle'),
        modalWidth: '33%',
      };
    },
    errorsCount() {
      return this.errors?.length || 0;
    },
  },
};
</script>
